<ape-admin-page-container
  class="w-full h-full flex flex-col self-stretch flex-1"
  [title]="TRANSLATION_KEYS.admin.monitoring.PLACEHOLDER_TITLE | translate"
  [showBackButton]="true"
  [subtitleOnBottom]="true"
  (backClick)="backClick.emit()"
>
  <ng-template #subtitle>
    <div class="flex justify-start items-center gap-2">
      <span class="text-base font-normal text-black">
        {{TRANSLATION_KEYS.admin.monitoring.details.SUBTITLE | translate}} <b>{{processName}}.</b>
      </span>
    </div>
  </ng-template>

  <monitoring-details-counters-template [monitoringDetailsCountersCardData]="monitoringDetailsCountersCardData" />

  <div class="flex flex-row flex-wrap lg:flex-nowrap sm:gap-6 items-start sm:items-center gap-4 w-full">
    <ape-download-button
      [iconSrc]="'assets/icons/xls.svg'"
      [downloadId]="'monitoring-process-report-download'"
      (downloadClick)="onExportProcessReport.emit($event)"
    />

    <ape-button
      class="w-full sm:w-auto"
      cssClass="!py-2.5 !px-3 !rounded-[4px] w-full !w-full !bg-white sm:whitespace-nowrap whitespace-normal"
      [label]="'admin.monitoring.details.SOLICIT_MASSIVE_SELF_EVALUATION_TITLE' | translate"
      [variant]="'primary'"
      [aspect]="'icon-outline'"
      [size]="'regular'"
      [rounded]="false"
      leftIcon="assets/icons/mail.svg"
      [disabled]="isSolicitMassiveSelfEvaluationDisabled"
      [isLoading]="isLoadingSolicitMassiveSelfEvaluation"
      (buttonClick)="showSolicitMassiveSelfEvaluationModal()"
    />

    <ape-button
      class="w-full sm:w-auto"
      cssClass="!py-2.5 !px-3 !rounded-[4px] !bg-white w-full !w-full sm:whitespace-nowrap whitespace-normal"
      [label]="'admin.monitoring.details.SOLICIT_MASSIVE_EVALUATION_TITLE' | translate"
      [variant]="'primary'"
      [aspect]="'icon-outline'"
      [size]="'regular'"
      [rounded]="false"
      leftIcon="assets/icons/mail.svg"
      [disabled]="isSolicitMassiveEvaluationDisabled"
      [isLoading]="isLoadingSolicitMassiveEvaluation"
      (buttonClick)="showSolicitMassiveEvaluationModal()"
    />

    <div class="flex flex-row items-center !w-full sm:w-auto sm:min-w-[200px]">
      <ape-input
        [cssClassInputWrapper]="'!w-full'"
        class="!w-full"
        [showLabelText]="false"
        [cssClass]="'!h-[46px] !w-full'"
        [value]="searchedText"
        (valueChange)="searchChange($event)"
        (onKeyUp)="searchUsers()"
        [placeholder]="TRANSLATION_KEYS.admin.monitoring.SEARCH_PLACEHOLDER | translate"
      />
      <div
        tabindex="0"
        role="button"
        (click)="searchUsers()"
        class="rounded-[0px_3px_3px_0px] h-[46px] w-[46px] text-base font-medium bg-black text-white p-[11px] flex flex-row items-center flex-shrink-0 cursor-pointer"
      >
        <svg-icon
          name="search"
          class="w-[24px] h-[24px]"
          src="assets/icons/search.svg"
          [attr.aria-hidden]="true"
        />
      </div>
    </div>
    <ape-button
      class="w-full sm:w-auto"
      (buttonClick)="advancedFiltersClicked()"
      cssClass="!py-2.5 !px-3 !rounded-[4px] !bg-black w-full !w-full whitespace-nowrap flex-shrink-0"
      [label]="TRANSLATION_KEYS.admin.monitoring.ADVANCED_FILTERS | translate"
      [variant]="'primary'"
      [aspect]="'icon'"
      [size]="'regular'"
      [rounded]="false"
      leftIcon="assets/icons/funnel.svg"
    />
  </div>

  <div
    *ngIf="getActiveFiltersOnPage().length > 0"
    class="w-full flex flex-row items-center"
  >
    <div class="flex flex-row flex-wrap gap-[10px] max-md:flex-nowrap overflow-x-auto">
      <ape-status-badge
        [withCloseIcon]="true"
        *ngFor="let filter of getActiveFiltersOnPage(); trackBy: trackByFn"
        [aspect]="'filter'"
        [kind]="'active-filter'"
        [label]="filter.title"
        [clickable]="true"
        (onCloseBadge)="removeFilterFromPage(filter)"
      />
    </div>
  </div>

  <div class="w-full h-[1px] bg-[#EEEEEE] mt-[-22px]"></div>

  <div
    class="w-full flex flex-col sm:flex-row sm:justify-between items-start sm:items-center gap-4 sm:gap-6 mt-[-32px]">
    <div class="flex flex-row items-center flex-wrap gap-2">
      <p class="text-base font-bold text-[var(--colors-gray-scale-black)]">{{ getActiveFiltersOnPage().length }}</p>
      <p class="text-base font-light text-[var(--colors-gray-scale-black)]">
        {{ getActiveFiltersOnPage().length === 1 ?
        (TRANSLATION_KEYS.admin.monitoring.ACTIVE_FILTER | translate) :
        (TRANSLATION_KEYS.admin.monitoring.ACTIVE_FILTERS | translate) }}
      </p>
      <p class="text-base font-bold text-[var(--colors-gray-scale-black)]">
        {{ usersDataCount }}</p>
      <p class="text-base font-light text-[var(--colors-gray-scale-black)]">
        {{ usersDataCount === 1 ?
        (TRANSLATION_KEYS.admin.monitoring.RESULT | translate) :
        (TRANSLATION_KEYS.admin.monitoring.RESULTS | translate) }}
      </p>
    </div>
    <div class="flex flex-row items-center w-full sm:w-auto">
      <ape-select
        class="!w-full sm:!w-auto"
        [isOrderSelect]="true"
        [placeholder]="''"
        [options]="sortOptions"
        [selectedOption]="selectedSortOption"
        optionLabel="title"
        optionValue="id"
        (selectedOptionChange)="onSortChange.emit($event)"
      />
    </div>
  </div>

  <div class="w-full h-[1px] bg-[#EEEEEE] mt-[-12px]"></div>

  <!-- Tabella utenti -->
  <ape-admin-monitoring-users-table
    class="mt-[-32px]"
    (accessProcess)="onAccessProcess.emit($event)"
    (impersonateUser)="onImpersonateUser.emit($event)"
    (impersonateManager)="onImpersonateManager.emit($event)"
    [usersData]="usersDataAsMonitoringUserSummaryExtended"
    [allUsersData]="allUsersData"
    [allUsersChecked]="allUsersChecked"
    [processId]="processId"
    (onAllUsersCheckedChange)="allUsersCheckedChange($event)"
    (onReopenEvaluation)="showReopenEvaluationModal($event)"
    (onReopenSelfEvaluation)="showReopenSelfEvaluationModal($event)"
    (onReopenCalibratedScorecard)="showReopenCalibratedScorecardModal($event)"
    (onReopenSharedScorecard)="showReopenSharedScorecardModal($event)"
    (onSolicitEvaluation)="showSolicitEvaluationModal($event)"
    (onSolicitSelfEvaluation)="showSolicitSelfEvaluationModal($event)"
    *ngIf="usersData.length > 0 && !loadingUsersData && !loadingUsersDataCount && !loading"
    (onDownloadEvaluationCard)="onDownloadEvaluationCard.emit($event)"
    (onSendCalibrationCards)="sendCalibrationCards($event)"
    (onGoToHandleListFeedback360)="onGoToHandleListFeedback360.emit($event)"
    (onGoToEvaluationCards)="onGoToEvaluationCards.emit($event)"
    (onOpenHrComment)="openHrCommentDrawer($event)"
  />

  <div
    *ngIf="getSelectedUsersCount() > 0 && !loadingUsersData && !loadingUsersDataCount && !loading"
    class="w-full h-full flex flex-row gap-4 items-center bg-white px-8 py-4 sticky bottom-[0] left-[0] z-[1]
      shadow-[0_-10px_20px_0_rgba(0,0,0,0.04),0_-2px_6px_0_rgba(0,0,0,0.04),0_0_1px_0_rgba(0,0,0,0.04)]"
  >
    <div class="flex flex-col items-center gap-1 w-[100px]">
      <p class="w-full font-black text-3xl leading-[30px] text-[#333333]">{{ getSelectedUsersCount() }}</p>
      <p class="w-full text-[14px] font-normal leading-[22px] text-[#727272]">
        {{TRANSLATION_KEYS.admin.monitoring.SELECTED_USERS | translate}}</p>
      <!-- Spec §9.1: la voce Deseleziona -->
      <ape-button
        class="w-full"
        [variant]="'link'"
        [aspect]="'link'"
        [size]="'small'"
        [label]="TRANSLATION_KEYS.admin.monitoring.DESELECT | translate"
        (buttonClick)="deselectAllUsers()"
      />
    </div>
    <div class="w-full flex flex-wrap gap-4 justify-center items-center">
      <!-- CA-1: la matrice si apre in consultazione sulle persone selezionate -->
      <ape-button
        [disabled]="getSelectedUsersCountCanAccessMatrix() === 0"
        (buttonClick)="openCompareMatrixModal()"
        variant="secondary"
        size="large"
        minWidth="182px"
        [label]="TRANSLATION_KEYS.admin.monitoring.COMPARE_IN_MATRIX | translate"
      />
      <ape-button
        [disabled]="getSelectedUsersCountCanConfirmAndSend() === 0"
        (buttonClick)="confirmAndSend()"
        minWidth="182px"
        size="large"
        [label]="TRANSLATION_KEYS.admin.calibrationTalentMatrix.CONFIRM_AND_SEND | translate"
      />
    </div>
    <div class="w-[100px]">&nbsp;</div>
  </div>

  <!-- Paginazione -->
  <ape-table-pagination
    [total]="totalPages"
    [page]="page"
    [pageSize]="pageSize"
    (pageChange)="onPageChange.emit($event)"
    (pageSizeChange)="onPageSizeChange.emit($event)"
    *ngIf="usersData.length > 0 && !loadingUsersData && !loadingUsersDataCount && !loading"
  />

  <!-- placeholder pagina vuota -->
  <ape-page-placeholder
    *ngIf="!loading && usersData.length === 0 && !loadingUsersData && !loadingUsersDataCount"
    [title]="TRANSLATION_KEYS.admin.monitoring.AT_MOMENT | translate"
    [subtitle]="TRANSLATION_KEYS.admin.monitoring.NO_PERSON_INCLUDED | translate"
    [description]="TRANSLATION_KEYS.admin.monitoring.THERE_ARE_NOT_PERSONS_INCLUSED_ON_PROCESS | translate"
  />

  <ape-process-setup-skeleton *ngIf="loading || loadingUsersData || loadingUsersDataCount" />
</ape-admin-page-container>

<!-- Spec §9.1: modale "Avvia matrice di comparazione" -->
<ape-modal
  [visible]="showCompareMatrixModal"
  [title]="TRANSLATION_KEYS.admin.monitoring.COMPARE_MATRIX_MODAL_TITLE | translate"
  [description]="TRANSLATION_KEYS.admin.monitoring.COMPARE_MATRIX_MODAL_DESCRIPTION | translate"
  [primaryActionLabel]="TRANSLATION_KEYS.admin.monitoring.COMPARE_MATRIX_MODAL_CONFIRM | translate"
  [secondaryActionLabel]="TRANSLATION_KEYS.generic.CANCEL | translate"
  [dismissableMask]="false"
  (onConfirm)="goToMatrix()"
  (onCancel)="closeCompareMatrixModal()"
  (onClose)="closeCompareMatrixModal()"
/>

<!-- Spec §9.5: drawer del Commento di HR, dalla voce di menu della lista -->
<ape-calibration-hr-comment-drawer
  [visible]="!!hrCommentUser"
  [processId]="processId || ''"
  [userId]="hrCommentUser?.userId || ''"
  [userFullName]="hrCommentUserFullName"
  (close)="closeHrCommentDrawer()"
  (saved)="onHrCommentSaved($event)"
/>

<!-- Modale di conferma -->
<ape-calibration-talent-matrix-confirmation-modal
  (cancel)="onCancelModalHandler()"
  (close)="onCloseModalHandler()"
  (confirm)="onConfirmModalHandler()"
  [isOpen]="showConfirmationModal"
  [notEligibleCount]="notEligibleUsersCount"
  [summary]="confirmationSummary"
/>

<!-- Drawer per i filtri utenti -->
<ape-monitoring-details-filter-process-drawer
  [visible]="isDrawerVisible"
  [feedback360StatusOptions]="feedback360StatusOptions"
  [selfAssessmentStatusOptions]="selfAssessmentStatusOptions"
  [evaluationStatusOptions]="evaluationStatusOptions"
  [deliveryStatusOptions]="deliveryStatusOptions"
  [companyOptions]="companyOptions"
  [officeOptions]="officeOptions"
  [departmentOptions]="departmentOptions"
  [buOptions]="BUOptions"
  [evaluatorOptions]="evaluatorsOptions"
  [selectedFeedback360Statuses]="selectedFeedback360Statuses"
  [selectedSelfAssessmentStatuses]="selectedSelfAssessmentStatuses"
  [selectedEvaluationStatuses]="selectedEvaluationStatuses"
  [selectedDeliveryStatuses]="selectedDeliveryStatuses"
  [selectedCompanies]="selectedCompanies"
  [selectedOffices]="selectedOffices"
  [selectedDepartments]="selectedDepartments"
  [selectedBUs]="selectedBUs"
  [selectedEvaluators]="selectedEvaluators"
  [title]="'admin.monitoring.FILTERS' | translate"
  [cancelLabel]="'generic.CANCEL' | translate"
  [confirmLabel]="'admin.monitoring.APPLY_FILTERS' | translate"
  [activeFiltersCount]="getActiveFiltersOnPage().length"
  (feedback360StatusesChange)="onFeedback360StatusesChangeHandler($event)"
  (selfAssessmentStatusesChange)="onSelfAssessmentStatusesChangeHandler($event)"
  (evaluationStatusesChange)="onEvaluationStatusesChangeHandler($event)"
  (deliveryStatusesChange)="onDeliveryStatusesChangeHandler($event)"
  (companyChange)="onCompanyChangeHandler($event)"
  (evaluatorChange)="onEvaluatorChangeHandler($event)"
  (departmentChange)="onDepartmentChangeHandler($event)"
  (officeChange)="onOfficeChangeHandler($event)"
  (buChange)="onBUChangeHandler($event)"
  (onConfirm)="onApplyFilters.emit()"
  (onResetFilters)="resetFilters()"
  (onCancel)="onCloseDrawer.emit()"
/>

<!-- Modale conferma riapertura valutazione -->
<ape-modal
  [visible]="isVisibleReopenEvaluationModal"
  [title]="'admin.monitoring.details.REOPEN_EVALUATION_TITLE' | translate"
  [secondaryActionLabel]="'generic.CANCEL' | translate"
  [primaryActionLabel]="'admin.monitoring.details.CONFIRM_REOPEN' | translate"
  (onCancel)="onCancelReopenEvaluation()"
  (onConfirm)="onConfirmReopenEvaluation()"
  (onClose)="onCancelReopenEvaluation()"
>
  <div class="w-full max-w-[820px]">
    <div [innerHTML]="'admin.monitoring.details.REOPEN_EVALUATION_DESCRIPTION' | translate: {managerFullName:
        $safeNavigationMigration(selectedUser?.managerForename) + ' ' + $safeNavigationMigration(selectedUser?.managerSurname), userFullName: $safeNavigationMigration(selectedUser?.forename) + ' ' +
        $safeNavigationMigration(selectedUser?.surname)}"></div>
    <div class="mt-4"><strong>{{'admin.monitoring.details.REOPEN_EVALUATION_SUBTITLE' | translate}}</strong>
    </div>
  </div>
</ape-modal>

<!-- RF-303 - Modale conferma riapertura scheda calibrata -->
<ape-modal
  [visible]="isVisibleReopenCalibratedScorecardModal"
  [title]="'admin.monitoring.details.REOPEN_CALIBRATED_SCORECARD_TITLE' | translate"
  [secondaryActionLabel]="'generic.CANCEL' | translate"
  [primaryActionLabel]="'admin.monitoring.details.CONFIRM_REOPEN' | translate"
  (onCancel)="onCancelReopenCalibratedScorecard()"
  (onConfirm)="onConfirmReopenCalibratedScorecard()"
  (onClose)="onCancelReopenCalibratedScorecard()"
>
  <div class="w-full max-w-[820px]">
    <div [innerHTML]="'admin.monitoring.details.REOPEN_CALIBRATED_SCORECARD_DESCRIPTION' | translate: {managerFullName:
        $safeNavigationMigration(selectedUser?.managerForename) + ' ' + $safeNavigationMigration(selectedUser?.managerSurname), userFullName: $safeNavigationMigration(selectedUser?.forename) + ' ' +
        $safeNavigationMigration(selectedUser?.surname)}"></div>
  </div>
</ape-modal>

<!-- RF-303 - Modale conferma riapertura scheda condivisa -->
<ape-modal
  [visible]="isVisibleReopenSharedScorecardModal"
  [title]="'admin.monitoring.details.REOPEN_SHARED_SCORECARD_TITLE' | translate"
  [secondaryActionLabel]="'generic.CANCEL' | translate"
  [primaryActionLabel]="'admin.monitoring.details.CONFIRM_REOPEN' | translate"
  (onCancel)="onCancelReopenSharedScorecard()"
  (onConfirm)="onConfirmReopenSharedScorecard()"
  (onClose)="onCancelReopenSharedScorecard()"
>
  <div class="w-full max-w-[820px]">
    <div [innerHTML]="'admin.monitoring.details.REOPEN_SHARED_SCORECARD_DESCRIPTION' | translate: {managerFullName:
        $safeNavigationMigration(selectedUser?.managerForename) + ' ' + $safeNavigationMigration(selectedUser?.managerSurname), userFullName: $safeNavigationMigration(selectedUser?.forename) + ' ' +
        $safeNavigationMigration(selectedUser?.surname)}"></div>
  </div>
</ape-modal>

<!-- Modale conferma riapertura auto-valutazione -->
<ape-modal
  [visible]="isVisibleReopenSelfEvaluationModal"
  [title]="'admin.monitoring.details.REOPEN_SELF_EVALUATION_TITLE' | translate"
  [secondaryActionLabel]="'generic.CANCEL' | translate"
  [primaryActionLabel]="'admin.monitoring.details.CONFIRM_REOPEN' | translate"
  (onCancel)="onCancelReopenSelfEvaluation()"
  (onConfirm)="onConfirmReopenSelfEvaluation()"
  (onClose)="onCancelReopenSelfEvaluation()"
>
  <div class="w-full max-w-[820px]">
    <div
      [innerHTML]="'admin.monitoring.details.REOPEN_SELF_EVALUATION_DESCRIPTION' | translate: {userFullName: $safeNavigationMigration(selectedUser?.forename) + ' ' + $safeNavigationMigration(selectedUser?.surname)}"
    ></div>
    <div class="mt-4"><strong>{{'admin.monitoring.details.REOPEN_EVALUATION_SUBTITLE' | translate}}</strong>
    </div>
  </div>
</ape-modal>

<!-- Modale conferma sollecito valutazione -->
<ape-modal
  [visible]="isVisibleSolicitEvaluationModal"
  [title]="'admin.monitoring.details.SOLICIT_EVALUATION_TITLE' | translate"
  [secondaryActionLabel]="'generic.CANCEL' | translate"
  [primaryActionLabel]="'admin.monitoring.details.CONFIRM_SOLICIT_EVALUATION' | translate"
  (onCancel)="onCancelSolicitEvaluation()"
  (onConfirm)="onConfirmSolicitEvaluation()"
  (onClose)="onCancelSolicitEvaluation()"
>
  <div class="w-full max-w-[820px]">
    <div
      [innerHTML]="'admin.monitoring.details.SOLICIT_EVALUATION_DESCRIPTION' | translate: {userFullName: $safeNavigationMigration(selectedUser?.forename) + ' ' + $safeNavigationMigration(selectedUser?.surname), managerFullName: $safeNavigationMigration(selectedUser?.managerForename) + ' ' + $safeNavigationMigration(selectedUser?.managerSurname)}"
    ></div>
    <div class="mt-4"><strong>{{'admin.monitoring.details.SOLICIT_SUBTITLE' | translate}}</strong> </div>
  </div>
</ape-modal>

<!-- Modale conferma sollecito auto-valutazione -->
<ape-modal
  [visible]="isVisibleSolicitSelfEvaluationModal"
  [title]="'admin.monitoring.details.SOLICIT_SELF_EVALUATION_TITLE' | translate"
  [secondaryActionLabel]="'generic.CANCEL' | translate"
  [primaryActionLabel]="'admin.monitoring.details.CONFIRM_SOLICIT_SELF_EVALUATION' | translate"
  (onCancel)="onCancelSolicitSelfEvaluation()"
  (onConfirm)="onConfirmSolicitSelfEvaluation()"
  (onClose)="onCancelSolicitSelfEvaluation()"
>
  <div class="w-full max-w-[820px]">
    <div
      [innerHTML]="'admin.monitoring.details.SOLICIT_SELF_EVALUATION_DESCRIPTION' | translate: {userFullName: $safeNavigationMigration(selectedUser?.forename) + ' ' + $safeNavigationMigration(selectedUser?.surname)}"
    ></div>
    <div class="mt-4"><strong>{{'admin.monitoring.details.SOLICIT_SUBTITLE' | translate}}</strong> </div>
  </div>
</ape-modal>

<!-- Modale conferma sollecito valutazione massiva-->
<ape-modal
  [visible]="isVisibleSolicitMassiveEvaluationModal"
  [title]="'admin.monitoring.details.SOLICIT_MASSIVE_EVALUATION_TITLE' | translate"
  [secondaryActionLabel]="'generic.CANCEL' | translate"
  [primaryActionLabel]="'admin.monitoring.details.CONFIRM_SOLICIT_MASSIVE_EVALUATION' | translate"
  [primaryActionDisabled]="isLoadingSolicitMassiveEvaluation"
  (onCancel)="onCancelSolicitMassiveEvaluation()"
  (onConfirm)="onConfirmSolicitMassiveEvaluation()"
  (onClose)="onCancelSolicitMassiveEvaluation()"
>
  <div class="w-full max-w-[820px]">
    <div [innerHTML]="'admin.monitoring.details.SOLICIT_MASSIVE_EVALUATION_DESCRIPTION' | translate"></div>
    <div class="mt-4"><strong>{{'admin.monitoring.details.SOLICIT_SUBTITLE' | translate}}</strong> </div>
  </div>
</ape-modal>

<!-- Modale conferma sollecito autovalutazione massiva-->
<ape-modal
  [visible]="isVisibleSolicitMassiveSelfEvaluationModal"
  [title]="'admin.monitoring.details.SOLICIT_MASSIVE_SELF_EVALUATION_TITLE' | translate"
  [secondaryActionLabel]="'generic.CANCEL' | translate"
  [primaryActionLabel]="'admin.monitoring.details.CONFIRM_SOLICIT_MASSIVE_SELF_EVALUATION' | translate"
  [primaryActionDisabled]="isLoadingSolicitMassiveSelfEvaluation"
  (onCancel)="onCancelSolicitMassiveSelfEvaluation()"
  (onConfirm)="onConfirmSolicitMassiveSelfEvaluation()"
  (onClose)="onCancelSolicitMassiveSelfEvaluation()"
>
  <div class="w-full max-w-[820px]">
    <div [innerHTML]="'admin.monitoring.details.SOLICIT_MASSIVE_SELF_EVALUATION_DESCRIPTION' | translate"></div>
    <div class="mt-4"><strong>{{'admin.monitoring.details.SOLICIT_SUBTITLE' | translate}}</strong> </div>
  </div>
</ape-modal>